export const lastUserDetailsKey = 'last-user-details';
export const tempUserIdKey = 'temporary-user-id';
